/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechCamVideoOffIcon24Solid = forwardRef('TechCamVideoOffIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.134 1.366A1.25 1.25 0 1 0 .366 3.134l2.07 2.07A4.488 4.488 0 0 0 1 8.5v7A4.5 4.5 0 0 0 5.5 20h8c1.047 0 2.01-.358 2.775-.957l3.591 3.59a1.25 1.25 0 0 0 1.768-1.767l-19.5-19.5Z" }),
        React.createElement("path", { d: "M24 16.585c0 1.008-.94 1.667-1.826 1.467L8.12 4H13.5A4.5 4.5 0 0 1 18 8.5v.286l3.628-2.592c.993-.709 2.372 0 2.372 1.22v9.171Z" })));
});
